@if (test) {
  <app-test-form
    [test]="test"
    [patient]="patient"
    action="{{ 'view' | translate }}"
    [isDisabled]="true">
  </app-test-form>
}
